import styled from "styled-components";

import { getOpacityColor, grayScale } from "@enkor/design/colors";

export const MenuList = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;

  width: 100%;
  padding: 16px 24px;

  cursor: pointer;

  transition: all 0.3s ease-in-out;

  &:hover {
    background: ${getOpacityColor(grayScale.white, 0.1)};
  }
`;
